import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Datamap from 'react-datamaps';
import d3 from 'd3';

import { CDN_PROVIDERS } from '../../constants/cdnConstants';
import { getRemotePartialPath, getPath } from './MultiCdnUtils';

import globalData from './GlobalData.tsv';

const radius = 12;
const bubbleColor = '#606961';
const akColor = 'rgb(255,102,0)';
const fyColor = 'rgb(233,44,45)';
const cfColor = 'rgb(219,159,17)';
const mcColor = 'rgb(0,113,186)';

const rawData = {};
(function prepareData() {
    globalData.forEach(dataUnit => {
        rawData[dataUnit.path] = rawData[dataUnit.path] || {};
        rawData[dataUnit.path][dataUnit.city] = rawData[dataUnit.path][dataUnit.city] || {};
        const hostKey = /idemo-([^\.]+)/.exec(dataUnit.host)[1];
        rawData[dataUnit.path][dataUnit.city][hostKey] = {
            host: dataUnit.host,
            median: parseFloat(dataUnit.median)
        };
    });

})();

const getBubbles = function () {
    return [
        {
            name: 'San Jose',
            radius,
            country: 'USA',
            latitude: 37.2966853,
            longitude: -122.0975973
        },
        {
            name: 'Dulles',
            radius,
            country: 'USA',
            latitude: 38.9541077,
            longitude: -77.496101
        },
        {
            name: 'London',
            radius,
            country: 'UK',
            latitude: 51.501364,
            longitude: -0.1440787
        },
        {
            name: 'Buenos Aires',
            radius,
            latitude: -34.6157142,
            longitude: -58.5033602
        },
        {
            name: 'Sydney',
            radius,
            latitude: -33.8567844,
            longitude: 151.213108
        },
        {
            name: 'Hong Kong',
            radius,
            latitude: 22.3574372,
            longitude: 113.8408289
        }
    ];
};

class CdnMap extends Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const isSameImage = this.props.image.public_id === nextProps.image.public_id;
        const isSameTransformation = Object.keys(this.props.transformation).sort().toString() ===
            Object.keys(nextProps.transformation).sort().toString();
        return !(isSameImage && isSameTransformation);
    }

    render() {
        // Get stats for all providers
        return (
            <Datamap
                projection="mercator"
                setProjection={function (element, options) {
                    var projection, path;
                    var long = 0;
                    var lat = 0;
                    projection = d3.geo.mercator()
                        .center([long, lat])
                        .scale(element.offsetWidth / 8.3)
                        .translate([element.offsetWidth / 2, element.offsetHeight / 1.6]);
                    path = d3.geo.path()
                        .projection(projection);

                    return { path: path, projection: projection };
                }}
                responsive
                fills={{
                    defaultFill: '#ABCDEF', //the keys in this object map to the "fillKey" of [data] or [bubbles]
                    ak: akColor,
                    fy: fyColor,
                    cf: cfColor,
                    mc: mcColor
                }}
                geographyConfig={{
                    popupOnHover: false,
                    highlightOnHover: false,
                    hideHawaiiAndAlaska: true,
                    borderOpacity: 0
                }}
                bubbles={getBubbles()
                    .map(bubble => {
                        const partialPath = getRemotePartialPath(this.props.image, this.props.transformation, bubble.name);
                        bubble.thisCityStats = rawData[partialPath][bubble.name];
                        bubble.fillKey = Object.keys(bubble.thisCityStats).reduce(
                            (previousCdnKey, currentCdnKey) => {
                                if (bubble.thisCityStats[previousCdnKey].median < bubble.thisCityStats[currentCdnKey].median) {
                                    return previousCdnKey;
                                }
                                return currentCdnKey;
                            }
                        );
                        return bubble;
                    })}
                bubbleOptions={{
                    popupTemplate: (geo, data) => {
                        // Needs to return plain text - d3 is setting this into innerHtml
                        const cityResults = Object.keys(data.thisCityStats)
                            .sort((leftCdnKey, rightCdnKey) =>
                                data.thisCityStats[leftCdnKey].median - data.thisCityStats[rightCdnKey].median)
                            .map(
                            (cdnKey, i) => `<div>${i + 1}. ${CDN_PROVIDERS[cdnKey].code}: ${data.thisCityStats[cdnKey].median}ms</div>`
                            );
                        return `
                            <div class="hoverinfo">
                                <div><strong>${data.name}</strong></div>
                                ${cityResults.join('')}
                            </div>`;
                    },
                    highlightFillColor: bubbleColor
                }} />

        );
    }
}

CdnMap.PropTypes = {
    image: PropTypes.string.isRequired,
    transformation: PropTypes.object.isRequired
};

export default CdnMap;



/** WEBPACK FOOTER **
 ** ./src/js/components/MultiCdn/CdnMap.js
 **/